import { ModuleWithProviders } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import {FeaturesComponent} from "./features.component";
import {ProductFilterComponent} from "./product/product-filter/product-filter.component";
import {ProductsComponent} from "./product/products.component";
import {CartComponent} from "./cart/cart.component";
import {ProductDetailsComponent} from "./product/product-details/product-details.component";
import {ListingComponent} from "./product/listing/listing.component";
import {authGuard} from "../core/guards/auth.guard";
import {LoginComponent} from "./components/auth/login/login.component";
import {SignupComponent} from "./components/auth/signup/signup.component";
import { RegisterComponent } from "./components/auth/register/register.component";
import {FestiveSocialMediaOffer2Component} from "./components/festive-social-media-offer-2/festive-social-media-offer-2.component";
import {FestiveStoreOffer2Component} from "./components/festive-store-offer-2/festive-store-offer-2.component";
import {ReachUsComponent} from "./components/policy/reach-us/reach-us.component";
import {OrderStatusComponent} from "./components/order-status/order-status.component";
import {PolicyComponent} from "./components/policy/policy.component";
import {CancelOrderComponent} from "./components/cancel-order/cancel-order.component";
import {HomepageResolver} from "../homepage-resolver.service";
import {HomeComponent} from "./home/home.component";

/**
 * Created by vikas on 09-01-2025.
 */
const router: Routes = [
  {
    path: '',
    component: FeaturesComponent,
    children: [
      { path: '', component: ProductsComponent, resolve: { banners: HomepageResolver } },
      { path: 'home', component: HomeComponent, resolve: { banners: HomepageResolver } },
      { path: 'user', loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule) , canActivate: [authGuard],},
      { path: 'search', component: ProductFilterComponent, data: { title: "Search" } },
      { path: 'cart', component: CartComponent, data: { title: "Cart" } },
      { path: 'product/:id', component: ProductDetailsComponent, data: { title: "Product Details" } },
      { path: 'products/:page', component: ListingComponent, data: { title: "Smart Dukaan" } },
      { path: 'login', component: LoginComponent, data: { title: "Smart Dukaan" } },
      { path: 'register', component: SignupComponent, data: { title: "Smart Dukaan" } },
      { path: 'auth', component: RegisterComponent, data: { title: "Smart Dukaan" } },
      // Legacy /offer, /spin and /festive-login URLs all land on the active in-store Patakha
      // Fodo page (/festive-store-offer-2). The old DiwaliLandingComponent + its OTP bounce
      // are retired now that festive-store-offer-2's iframe owns the full post-bill flow
      // (session resume via auth:probe, OTP via postMessage bridge, gift reveal + redeem).
      // Marketing/QR links printed on retailer standees still point at /offer and /spin, so
      // the redirects stay so existing links keep working through the Diwali 2026 window.
      { path: 'offer', redirectTo: 'festive-store-offer-2', pathMatch: 'full' },
      { path: 'spin', redirectTo: 'festive-store-offer-2', pathMatch: 'full' },
      { path: 'festive-login', redirectTo: 'festive-store-offer-2', pathMatch: 'full' },
      // Old /festive-social-media-offer route redirects to -2 (the active page).
      // The /festive-social-media-offer prefix check in features.component.ts#isPublicLandingUrl
      // still catches both URLs so the header/footer stay hidden across the redirect.
      { path: 'festive-social-media-offer', redirectTo: 'festive-social-media-offer-2', pathMatch: 'full' },
      { path: 'festive-social-media-offer-2', component: FestiveSocialMediaOffer2Component, data: { title: "Diwali Unlimited Dhamaka" } },
      { path: 'festive-store-offer-2', component: FestiveStoreOffer2Component, data: { title: "Diwali Unlimited Dhamaka — Store" } },
      { path: 'reach-us', component: ReachUsComponent, data: { title: "Smart Dukaan" } },
      { path: 'order-status/:pendingOrderId', component: OrderStatusComponent, data: { title: "Smart Dukaan" } },
      { path: 'cancel-order', component: CancelOrderComponent, data: { title: "Smart Dukaan" } },
      { path: ':policyType', component: PolicyComponent, data: { title: "Smart Dukaan" } },
    ]
  }
];


export const routing: ModuleWithProviders<any> = RouterModule.forChild(router);
